import React from "react";

import {
  Col,
  Row,
  Breadcrumb,
  BreadcrumbItem,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const Header = ({ searchText, onSearchUsers }) => {
  return (
    <Row className="mb-2 mb-xl-4">
      <Col xs="auto">
        <Breadcrumb>
          <BreadcrumbItem>Admin</BreadcrumbItem>

          <BreadcrumbItem active>Manage Users</BreadcrumbItem>
        </Breadcrumb>
      </Col>

      <Col xs="auto" className="ml-auto text-right mt-n1">
        <InputGroup className="mb-3">
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <FontAwesomeIcon icon={faSearch} className="mr-2" />
              Search Users
            </InputGroupText>
          </InputGroupAddon>

          <Input
            placeholder="User Name"
            name="searchUsers"
            value={searchText}
            onChange={onSearchUsers}
          />
        </InputGroup>
      </Col>
    </Row>
  );
};

export default Header;
